'use strict'

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';

import { getHistory } from '@/history';

import { usersOperations, usersSelectors } from '@/state/domains/users';
import { errorsSelectors, errorsOperations } from '@/state/domains/errors';

import s from './styles.scss';

const Page = ({ addError, loginSuccess }) => {

	//const navigate = useNavigate();

	const [ username, setUsername ] = useState('');
	const [ passphrase, setPassphrase ] = useState('');
	const [ redirect, setRedirect ] = useState(false);
	const [ user, setUser ] = useState(null);
	const [ loginError, setLoginError ] = useState(false);

	const onUsernameChange = e => {

		const username = e.target.value.replace(/^\s+|\s+$/g,'');
		setUsername(username);
	}

	const onPassphraseChange = e => {

		const passphrase = e.target.value.replace(/^\s+|\s+$/g,'');
		setPassphrase(passphrase);
	}

	const login = e => {

		e.preventDefault();

		const endPoint = '/login';
		const data = { username, passphrase };
		
		axios.post(endPoint, data).then(json => {

			const { data } = json;

			if (data && data.success) {

				const { user } = data.data;
				localStorage.setItem('user', JSON.stringify(user));
				loginSuccess(user);

				setRedirect(true);
				setUser(user);

			} else {
				addError(data.msg);
			}
		});
	}

	const history = getHistory();

	useEffect(() => {
		if (redirect && user) {

			const url = user.roles.includes('server') ||
				user.roles.includes('messenger') ?
				`/user/${ user.username }` :
				'/jobs';

			history.push(url);
		}
	});

	return (
		<div className={ s.loginCont }>
			<form>
				<div>
					<input
						type='text'
						autoFocus={ true }
						spellCheck={ false }
						autoCapitalize='off'
						placeholder='Username'
						onChange={ onUsernameChange }
						value={ username }
					/>
				</div>
				<div>
					<input
						type='password'
						placeholder='Passphrase'
						onChange={ onPassphraseChange }
						value={ passphrase }
					/>
				</div>
				<button type='submit' onClick={ login }>Sign in</button>
			</form>
		</div>
	);
};

export default connect(
	(state, props) => ({
	}),
	{
		loginSuccess: usersOperations.loginSuccess,
		addError: errorsOperations.addError,
	}
)(Page);
